import ConfigurableActivityIndicator from './components/ConfigurableActivityIndicator';

export default ConfigurableActivityIndicator;
